const url = 'https://capacitacionescontest.blistertechnologies.net/';
const socket = 'https://capacitacionescontest.blistertechnologies.net';

export const environment = {
  production: false,
  api: `${url}api/v1/`,
  socket: socket,
  socketApi: `${socket}/api/v2/`,
  socketImgs: `${socket}/api/v2/uploads/`,
  images: `${url}api/v1/uploads/`,
  webUrl: url,
  siteKey: '0x4AAAAAADGiRgrZ5aaZ1kH9',
};
